import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown, FileText } from 'lucide-react';
import { useGetList, useNotify } from 'ra-core';
import { useFormContext } from 'react-hook-form';

export const TermsTemplateSelector = ({ type }: { type: string }) => {
    const { data: templates, isLoading } = useGetList('terms_templates', {
        pagination: { page: 1, perPage: 100 },
        filter: { type }
    });
    
    const { setValue } = useFormContext();
    const notify = useNotify();

    if (isLoading || !templates || templates.length === 0) return null;

    const handleSelect = (content: string) => {
        setValue('terms_conditions', content, { shouldDirty: true, shouldValidate: true });
        notify('T&C template loaded', { type: 'success' });
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="secondary" size="sm" type="button" className="h-8">
                    <FileText className="w-4 h-4 mr-2" />
                    Load Template
                    <ChevronDown className="w-3 h-3 ml-2 opacity-50" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[300px]">
                {templates.map(t => (
                    <DropdownMenuItem 
                        key={t.id} 
                        onClick={() => handleSelect(t.content)}
                        className="cursor-pointer"
                    >
                        {t.name}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
